<template>
  <div class="item-col">
    <span v-if="title" class="item-title">{{ title }}: </span>
    <div v-if="$slots.default" class="item-text">
      <slot></slot>
    </div>
    <span v-else class="item-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'itemCol',
  props: {
    title: String,
    text: [String, Number],
  }
}
</script>

<style lang='scss' scoped>
.item-col {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  span {
    display: inline-block;
  }
  .item-title {
    width: fit-content;
    flex-shrink: 0;
    margin-right: 1em;
  }
  .item-text {
    // flex: 1;
    color: #606666;
    white-space: pre;
    word-wrap: break-word;
  }
}
</style>